import { styled } from "@mui/material/styles";
import CardActions from "@mui/material/CardActions";

export const StyledCardActions = styled(CardActions)(({ theme }) => ({
  justifyContent: "space-between",
  flexDirection: "column",
}));
